import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { Banner, QueryMarketingBannerArgs } from '@hdms/shared/common-types';

interface MarketingBannerResponse {
  marketingBanner: Banner;
}

@Injectable({
  providedIn: 'root'
})
export class MarketingBannerGqlService extends Query<MarketingBannerResponse, QueryMarketingBannerArgs> {
  override document = gql`
    query MarketingBanner($filter: MarketingBannerFilterInput!, $localization: LocalizationInput!) {
      marketingBanner(filter: $filter, localization: $localization) {
        id
        headline
        subHeadline
        imageUri
        imageAlt
        layout
        displayDelay
        links {
          uri
          openInNewTab
          label
        }
        webAnalyticsData {
          trackName
          trackId
          trackCreative
        }
      }
    }
  `;
}
